// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FbQbcmdn6g .cp-container [role='dialog'] {
	z-index: 350;
}
`, "",{"version":3,"sources":["webpack://./../../next/packages/main-layout/src/styles.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb","sourcesContent":[".dialogStyle :global(.cp-container [role='dialog']) {\n\tz-index: 350;\n}\n"],"sourceRoot":""}]);
// Exports
export var dialogStyle = `FbQbcmdn6g`;
export default ___CSS_LOADER_EXPORT___;
